import { Flex } from "@chakra-ui/react";
import ContentFiltro from "./ContentFiltro";
import { FiltroPrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings/index";

const meses = [
  { mes: "Janeiro", id: "01" },
  { mes: "Fevereiro", id: "02" },
  { mes: "Março", id: "03" },
  { mes: "Abril", id: "04" },
  { mes: "Maio", id: "05" },
  { mes: "Junho", id: "06" },
  { mes: "Julho", id: "07" },
  { mes: "Agosto", id: "08" },
  { mes: "Setembro", id: "09 " },
  { mes: "Outubro", id: "10" },
  { mes: "Novembro", id: "11" },
  { mes: "Dezembro", id: "12" },
];

interface FiltroPeriodoProps {
  filtro: FiltroPrevisaoOrcamentaria;
  onChangeFiltro: (filtro: Partial<FiltroPrevisaoOrcamentaria>) => any;
  showMediaMensal?: boolean;
}

export default function FiltroPeriodo({
  filtro,
  onChangeFiltro,
  showMediaMensal = false,
}: FiltroPeriodoProps) {
  return (
    <Flex gridGap={2} mb={8} wrap="wrap" justifyContent="space-between">
      {meses.map((mes) => (
        <ContentFiltro
          w="80px"
          title={mes.mes}
          key={mes.id}
          isSelected={filtro?.mes === mes.id && !filtro.media}
          onClick={() => onChangeFiltro({ mes: mes.id, media: undefined })}
        />
      ))}

      {showMediaMensal ? (
        <ContentFiltro
          w="140px"
          title="Média Mensal"
          isSelected={!filtro.mes && !!filtro.media}
          onClick={() =>
            onChangeFiltro({
              media: filtro.media ? undefined : "1",
              mes: undefined,
            })
          }
        />
      ) : null}

      <ContentFiltro
        w="140px"
        title="Previsão Anual"
        isSelected={!filtro.mes && !filtro.media}
        onClick={() =>
          onChangeFiltro({
            mes: undefined,
            media: undefined,
          })
        }
      />
    </Flex>
  );
}
